import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Annee } from '../model/annee';

@Injectable({
    providedIn: 'root'
  })
  export class AnneeService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    getAll() 
    {
        return this._restClientService.load<Annee[]>('annee/get-all');
    }
    

}      

    